import { useIntl } from 'gatsby-plugin-intl';
import Parser from 'html-react-parser';
import React from 'react';

import Article, {
  ArticleHeader, ArticleTitle, ArticleContent,
} from 'components/Article';

interface StaticPageProps {
  id: string;
}

const StaticPage: React.FC<StaticPageProps> = ({ id }) => {
  const { locale } = useIntl();
  const lang = locale === 'en' ? 'en-us' : 'fr';

  const API = `https://albums.zendesk.com/api/v2/help_center/${lang}/articles/${id}.json`;
  const [data, setData] = React.useState<StaticArticles>();

  // eslint-disable-next-line
  React.useEffect((): any => {
    fetch(API)
      .then((response) => response.json())
      .then((Data) => {
        setData(Data.article);
      });
  }, [API]);

  const content = data && Parser(data.body);

  return (
    <Article>
      <ArticleHeader>
        <ArticleTitle level={1}>
          {data?.title}
        </ArticleTitle>
      </ArticleHeader>
      <ArticleContent>
        {content}
      </ArticleContent>
    </Article>
  );
};

export default StaticPage;
